import { Flex } from 'rebass'
import {
  border,
  borderRadius,
  boxShadow,
  position,
  left,
  top,
  right,
  space,
  display,
  height,
  width,
  color
} from 'styled-system'

const FlexWithPosition = props => {
  return (
    <Flex
      {...props}
      css={[``, color, border, borderRadius, boxShadow, width, height, position, left, top, right, space, display]}>
      {props.children}
    </Flex>
  )
}

const DoubleCircleIcon = props => {
  return (
    <Flex {...props} justifyContent={'center'} alignItems={'center'}>
      <FlexWithPosition
        position={'relative'}
        height={'84px'}
        width={'84px'}
        border={'solid 1px rgba(219,217,218,0.6)'}
        borderRadius={'50%'}>
        <FlexWithPosition
          position={'absolute'}
          height={'66px'}
          width={'66px'}
          top={'50%'}
          left={'50%'}
          m={'-33px 0 0 -33px'}
          justifyContent={'center'}
          alignItems={'center'}
          bg={'#ffffff'}
          borderRadius={'50%'}
          boxShadow={'0 0 4px 0 rgba(0,0,0,0.1)'}>
          <FlexWithPosition
            position={'relative'}
            height={'24px'}
            width={'24px'}
            fontSize={'24px'}
            className={props.icon}>
            <FlexWithPosition
              top={'50%'}
              right={'-4px'}
              justifyContent={'center'}
              alignItems={'center'}
              position={'absolute'}
              height={props.checkIconSize || '18px'}
              width={props.checkIconSize || '18px'}
              fontSize={props.checkIconFontSize || '10px'}
              bg={props.checkIconBg || 'primary'}
              border={'2px solid #ffffff'}
              borderRadius={'50%'}
              color={'white.default'}
              className={props.checkIcon || 'zen-icon_ic_s-confirmed'}
            />
          </FlexWithPosition>
        </FlexWithPosition>
      </FlexWithPosition>
    </Flex>
  )
}

export default DoubleCircleIcon
